/**
 * Host que sirve las imágenes de producto (Express /images en la API).
 * En prod siempre api.cajasamanecer.com.ar, no el dominio del front.
 */
function getImagesBaseUrl() {
  const explicit = process.env.REACT_APP_IMAGES_BASE_URL;
  if (explicit != null && String(explicit).trim() !== '') {
    return String(explicit).trim().replace(/\/$/, '');
  }
  if (process.env.NODE_ENV === 'development') {
    return (
      process.env.REACT_APP_DEV_API_PROXY ||
      process.env.DEV_API_PROXY ||
      'http://127.0.0.1:3001'
    ).replace(/\/$/, '');
  }
  const api =
    process.env.REACT_APP_API_BASE_URL || 'https://api.cajasamanecer.com.ar';
  return String(api).trim().replace(/\/$/, '');
}

/**
 * Obtiene la URL correcta de una imagen, ya sea de Firebase Storage o local
 * @param {string} imagenURL - URL de la imagen o nombre del archivo
 * @returns {string|null} URL completa de la imagen
 */
export const obtenerURLImagen = (imagenURL) => {
  if (!imagenURL) {
    return null;
  }

  const raw = String(imagenURL).trim();
  if (raw.includes('firebasestorage')) {
    return raw;
  }

  let file = raw.replace(/^\/+/, '').replace(/^images\//, '');
  if (/^https?:\/\//i.test(raw)) {
    try {
      const parsed = new URL(raw);
      const marker = '/images/';
      const idx = parsed.pathname.indexOf(marker);
      if (idx === -1) {
        return raw;
      }
      file = parsed.pathname.slice(idx + marker.length).replace(/^\/+/, '');
    } catch (_) {
      return raw;
    }
  }

  if (!file) {
    return null;
  }

  return `${getImagesBaseUrl()}/images/${file}`;
};

/**
 * Lista ordenada de imágenes del producto (portada primero).
 * Compatible con productos legacy que solo tienen imagenURL.
 * @param {{ imagenes?: string[], imagenURL?: string|null }} producto
 * @returns {string[]}
 */
export const obtenerImagenesProducto = (producto) => {
  if (!producto) return [];
  const fromArray = Array.isArray(producto.imagenes)
    ? producto.imagenes.map((s) => String(s || '').trim()).filter(Boolean)
    : [];
  if (fromArray.length > 0) return fromArray;
  if (producto.imagenURL) return [String(producto.imagenURL).trim()].filter(Boolean);
  return [];
};

/**
 * Portada del producto (primera imagen de la galería).
 * @param {{ imagenes?: string[], imagenURL?: string|null }} producto
 * @returns {string|null}
 */
export const obtenerCoverImagen = (producto) => {
  const list = obtenerImagenesProducto(producto);
  return list[0] || null;
};
